<template>
 <section class="d-flex flex-column flex-wrap">
    <label class="fs-6">{{ title }}</label>
    <div class="d-flex flex-wrap ml-0 mt-0 mb-0 align-items-center" v-if="!editing">
      <div class="grow-1 mt-0 mr-2">
        <h2 class="title is-4 mt-0" v-if="value">{{ value }}</h2>
        <h2 class="title is-4 mt-0 text-muted" v-else>none set</h2>
      </div>
      <button @click="setEditing(true)" class="button mb-1 is-link" type="button">Edit</button>
    </div>

    <form v-else class="d-flex flex-wrap ml-0 mt-0 mb-0" @submit.prevent="saveValue">
      <input @keydown.esc="setEditing(false)" class="column ml-0 mt-0 input mr-2 mb-1" v-model="editedValue" :placeholder="placeholder" :id="'input-' + title"/>
      <div class="d-flex">
        <button @click="setEditing(false)" class="button mr-1 is-link grow-1" type="button">Cancel</button>
        <button type="submit" :class="loading && 'is-loading'" class="button is-info grow-1" :disabled="!edited">Save</button>
      </div>
    </form>
  </section>
</template>

<script>
  export default {
    name: 'SettingsProfileField',
    data () {
      return {
        editedValue: '',
        editing: false,
        loading: false,
      }
    },
    props: {
      title: {
        type: String,
        required: true,
      },
      value: {
        required: true,
      },
      placeholder: {
        type: String,
        default: '',
      },
      save: {
        type: Function,
        required: true,
      },
    },
    computed: {
      edited () {
        return this.value !== this.editedValue
      },
      ref () {
        return 'input-' + this.title
      },
    },
    methods: {
      saveValue () {
        if (!this.edited) { return }
        this.loading = true
        this.save(this.editedValue)
        .then(() => {
          this.editing = false
          this.loading = false
        })
      },
      setEditing (enableEditing) {
        if (enableEditing) {
          setTimeout(() => {
            const input = document.getElementById(this.ref)
            input.focus()
          }, 50)
        }
        this.editedValue = this.value
        this.editing = enableEditing
      },
    },
  }
</script>



// WEBPACK FOOTER //
// SettingsProfileField.vue?6ecf278a